import { PRODUCER_ZONE_URL_SEGMENT } from 'modules/producers/helpers/producers.const';

export default function getProducerMainPageUrlBySlug(producerSlug: string): string {
    return `/${PRODUCER_ZONE_URL_SEGMENT}/${producerSlug}`;
}
